/**
 * Registers the service worker that backs both push notifications and PWA install.
 *
 * `usePushNotifications` also registers `/sw.js` when a user subscribes; calling
 * register() twice for the same script and scope is a no-op in the browser, so the two
 * paths do not fight. This one runs on every load because the install prompt is only
 * offered once an active worker exists.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  // The dev server has no /sw.js, and a worker would sit in front of HMR
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => console.warn('[SW] Registration failed:', err));
  });
}

export default registerServiceWorker;
